import Vue from 'vue'
import App from './App.vue'
import API from "./azorult/api"
import const_ from "./azorult/const"
import utils from "./azorult/utils"
import router from './router'

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import MomentVue from 'vue-moment'
import BootstrapVue from 'bootstrap-vue'

import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/css/bootstrap-slate.css'
import '@/assets/css/fontello.css'
import '@/assets/css/azorult-tracker.scss'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://f8be10789b7e4c94afb7ea26b23f89e2@sentry.io/1875498',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
  })
}

Vue.config.productionTip = false

Vue.use(MomentVue)
Vue.use(BootstrapVue)

Vue.use(API, {
  // uri: 'https://azorult-tracker.net/api'
  uri: '/api'
})
Vue.use(const_)
Vue.use(utils)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
